import { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, DropdownCard, type IDropdownItem, type IIconsVector, Status } from 'shared/ui'
import { type IContactsDataParams } from 'entities/Contacts/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ChatbotEnrollStore } from 'widgets/ChatbotEnroll/store/ChatbotEnrollStore'
import styles from './styles.module.scss'

type IChatbotEnrollButtonProps = {
  contactsData: IContactsDataParams
  variant: 'dropdownItem' | 'button'
  onClick?: () => void
}

export const ChatbotEnrollAction = observer(
  ({ contactsData, onClick, variant }: IChatbotEnrollButtonProps) => {
    const text = 'Engage with AI Agent'
    const icon: IIconsVector = 'chatBot'
    const entities = useEntitiesContext()
    const [loading, setLoading] = useState(false)
    const store = useMemo(() => new ChatbotEnrollStore(entities), [])

    const { selectedIds, bulkAll, contactsParams, search } = contactsData

    const handleClick = () => {
      if (bulkAll) {
        store.enrollContactsByFilters(contactsParams?.filtersList, search, bulkAll)
        onClick?.()
      } else {
        setLoading(true)
        store.getValidContactIds(selectedIds).then((validContactIds) => {
          setLoading(false)
          onClick?.()

          if (validContactIds) store.enrollContacts(validContactIds)
        })
      }
    }

    useEffect(() => store.checkActivity(), [])

    if (!store.isOperationEnabled) return null

    if (variant === 'dropdownItem') {
      const item: IDropdownItem = {
        id: 'engage_in_aiAgent',
        iconL: icon,
        label: text,
        disabled: loading,
        labelContent: (
          <div className={styles.dropdownLabel}>
            {text}
            <Status title={'New'} intent={'purple'} emphasis={'high'} size={'label'} />
          </div>
        ),
      }
      return <DropdownCard item={item} onChange={handleClick} />
    }

    return (
      <Button
        text={text}
        icon={icon}
        typeBtn='contained'
        contained='tertiary'
        size='small'
        textRight={<Status title={'New'} intent={'purple'} emphasis={'high'} size={'label'} />}
        onClick={handleClick}
        loading={loading}
      />
    )
  }
)
